<script setup lang="ts">
import { provide, toRef } from 'vue';
import { inputActionsAlignInjectionKey, inputPlainCellInjectionKey } from './internal';

const props = withDefaults(
  defineProps<{
    /** `'start'` = lookup/goto on the left (right-aligned table cells). */
    align: 'start' | 'end';
    /**
     * Body ghost cells: the field paints as table text (no input shell, icons
     * overlay). Filter/create rows leave this off and keep a real input.
     */
    plainCell?: boolean;
  }>(),
  { plainCell: false }
);

provide(inputActionsAlignInjectionKey, toRef(props, 'align'));
provide(inputPlainCellInjectionKey, toRef(props, 'plainCell'));
</script>

<template>
  <slot />
</template>
